<template>
  <div id="services">
    <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
      <row
        class="rowa"
        v-for="(service, index) in filteredServices.lg1.slice(0, additionalServices? 7 : 8)"
        :key="index"
        :servicesLg1="service"
      ></row>
      <div
        id="additionalServices"
        v-if="additionalServices"
        class="d-flex flex-column align-items-left"
      >
        <div class v-html="additionalServices.lg1.label_value"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Row from "./rowServices";
import LegalNoticeCenter from "./legalNoticeCenter";

export default {
  name: "TribeRatesHorizontalV1Services",
  props: {
    servicesLg: Object,
  },
  components: {
    row: Row,
    legalNoticeCenter: LegalNoticeCenter,
  },
  computed: {
    filteredServices: function () {
      // remove additional services if necessary
      if (this.servicesLg.settings.additional_services === "1") {
        return {
          lg1: this.servicesLg.otherServices.regular.slice(0, -1).concat(this.servicesLg.otherServices.right),
        };
      } else {
        return {
          lg1: this.servicesLg.otherServices.regular.concat(this.servicesLg.otherServices.right),
        };
      }
    },
    additionalServices: function () {
      if (this.servicesLg.settings.additional_services === "1") {
        let regularLg1 = this.servicesLg.otherServices.regular;
        return {
          lg1: regularLg1[regularLg1.length - 1],
        };
      } else {
        return null;
      }
    },
    optionalServices: function () {
      // remove additional services if necessary
      return {
        lg1: this.servicesLg.otherServices.right,
      };
    },
  },
};
</script>

<style lang="scss">
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_tribe.scss";

#tribeRatesHorizontalV1 #services {
  width: 100%;
  height: 100%;

  #rows {
    width: 100%;
    height: 100%;

    /*
    .rowa:nth-of-type(n + 6) {
      display: none !important;
    }
    */
  }

  #additionalServices {
    //@include heightPercent(120);
    width: 100%;

    p {
      font-family: "Knockout";
      @include fontSize(47);
      margin-bottom: 0px;
      line-height: 2rem;
    }
    p:nth-of-type(2) {
      font-family: "Brown";
      color: $grey;
      @include fontSize(25);
    }

    border-bottom: 1px solid $grey;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/services/services.vue